import styled from 'styled-components';

import { BadgeButton } from '@components/badge-button';
import { IconFormIndicatorError } from '@components/icons/form-indicator-error';
import { IconFormIndicatorWarning } from '@components/icons/form-indicator-warning';
import { pxToRem } from '@utils/converters';

import { TravellerJourneyListItem } from 'api/types';

import { useTravellerIssuesSidebar } from '../../../travellers/traveller-issues-sidebar';

export const IssuesCell = ({ row: traveller }: { row: TravellerJourneyListItem }) => {
  const showIssueSidebar = useTravellerIssuesSidebar();
  const { shortId, journey: journeyShortId, companyTravellerShortId } = traveller;

  if (
    !traveller.issues ||
    (traveller.issues.warnings.length === 0 && traveller.issues.errors.length === 0)
  ) {
    return <span>-</span>;
  }

  const { warnings, errors } = traveller.issues;

  const onClick = () => {
    showIssueSidebar({
      warnings,
      errors,
      traveller: {
        journeyShortId,
        shortId,
        companyTravellerShortId,
      },
    });
  };

  return (
    <Container>
      {warnings.length > 0 && (
        <BadgeButton icon={IconFormIndicatorWarning} text={warnings.length} onClick={onClick} />
      )}

      {errors.length > 0 && (
        <BadgeButton icon={IconFormIndicatorError} text={errors.length} onClick={onClick} />
      )}
    </Container>
  );
};

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: pxToRem(2),
});
